var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"year-drop"},_vm._l((_vm.years),function(item,index){return _c('div',{key:index,staticClass:"year-drop-items"},[_c('p',{on:{"click":function($event){return _vm.sendYear(item.year)}}},[_vm._v(_vm._s(item.year))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }